import React, { useEffect, useState } from 'react'
import { FaVideoSlash } from 'react-icons/fa'
import RecentBallResults from '../components/RecentBallResults'
import LiveBattingTable from '../components/LiveBattingTable'
import TeamScores from '../components/TeamScores'
import './Cartoons.scss'
import BallResults from '../BallResults.json'

const Clip = ({ clip, overlayText, layout, gameType, fullscreenCartoon, cartoonOnly }) => {

    const [activeClipIndex] = useState(0)
    const [activeClipName, setActiveClipName] = useState(null)

    const videoRef = React.useRef(null)

    useEffect(() => {
        const videoPlayer = videoRef.current
        videoPlayer.loop = false

        let clips = clip.split(', ')
        setActiveClipName(clips[0])
        
        function playNextClip(e) {
            const newActiveClipIndex = activeClipIndex + 1

            if (e.target.src.includes('crowd') || e.target.src.includes('qcl12')) {
                videoPlayer.pause()
            } else if (clips[newActiveClipIndex]) {    
                setActiveClipName(clips[newActiveClipIndex])
    
                const promise = videoPlayer.play()
                if (promise !== undefined){
                    promise.then(() => {
    
                    }).catch(error => {
                        if (process.env.NODE_ENV === 'development') {
                            console.log(error)
                        }
                    })
                }
            } else {
                videoPlayer.loop = true
                videoPlayer.play()
            }
        }

        videoPlayer.addEventListener('ended', playNextClip)

        return () => {
            videoPlayer.removeEventListener('ended', playNextClip)
        }
    }, [clip, activeClipIndex])

    const showOverlay = overlayText && videoRef.current &&
        (videoRef.current.src.includes('crowd') || videoRef.current.src.includes('endgame'))

    return (
        <>
            <div className="overlay">
                { showOverlay && overlayText.length > 2 ? (
                    <div className="text">
                        {overlayText}
                    </div>
                ) : showOverlay ? (
                    <>
                        <div className="text">
                            {overlayText[0]}
                        </div>
                        <div className="text">
                            {overlayText[1]}
                        </div>
                    </>
                ) : null}
            </div>
            <video 
                src={`https://videos.decimalcricket.net/QCR/${activeClipName}`} 
                playsInline={true}
                webkit-playsinline="true"
                muted={true} // Chrome does not allow autoplay with sound
                autoPlay={true}
                width="100%"
                type="video/mp4"
                ref={videoRef}
                style={{ 
                    maxHeight: layout === 'single' && ! fullscreenCartoon && ! cartoonOnly ? '210px' : null,
                    paddingBottom: gameType === 'QUANTUM' ? '15px' : null, 
                 }}
            />
        </>
    )
}

export default function Cartoons({ clip, layout, teams, event, scorecard, scoregrid, scoreboard, backgroundColor, gameType, isHundred, fullscreenCartoon, cartoonOnly }) {
    if (!scorecard && gameType !== 'KABD') {
        return null
    }
    const { event_status } = scorecard

    let complete = false

    if (event_status.includes('Match Complete')) {
        complete = true
    }

    const { overs } = scoregrid || {};

    const { inns1, inns2, inns3, inns4 } = overs || {};

    let recentOvers = [];

    if (inns1){
        inns1.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    if (inns2){
        inns2.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    if (inns3){
        inns3.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    if (inns4){
        inns4.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    function getResultDescription(ball) {
        if (! ball) {
            return null
        }

        ball = ball.toLowerCase()
        const result = BallResults[ball]

        if (! result) {
            return null
        }

        return result.description.toUpperCase()
    }

    let overlayText = null;

    if (complete) {
        overlayText = event_status.replace('Match Complete -', '').replace('(V)', '(V)\n').split('\n')
        clip = "endgame.mp4"
    } else if (recentOvers && recentOvers.length) {
        overlayText = getResultDescription(recentOvers[0].balls[0])
    }

    return (
        <div className="cartoons" style={{ 
            backgroundColor, 
            display: layout === 'double' ? 'flex' : 'block',
         }}>
            { layout === 'single' && ! fullscreenCartoon && ! cartoonOnly && (
                <>
                    <TeamScores
                        teams={teams}
                        event={event}
                        scoreboard={scoreboard}
                        isHundred={isHundred}
                    />
                    <LiveBattingTable scoreboard={scoreboard} />
                </>
            ) }
            { clip ? ( 
                <div 
                    className="video-wrapper"
                    style={{
                        display: layout === 'double' ? 'flex' : 'block'
                    }}
                >
                    <Clip 
                        clip={clip} 
                        overlayText={overlayText} 
                        layout={layout} 
                        gameType={gameType}
                        fullscreenCartoon={fullscreenCartoon}
                        cartoonOnly={cartoonOnly}
                    />
                    { layout === 'single' && ! fullscreenCartoon && ! cartoonOnly && (
                        <RecentBallResults
                            scoregrid={scoregrid}
                        />
                    )}
                </div>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', color: 'white'}}>
                    <div style={{ textAlign: 'center'}}>
                        <FaVideoSlash size={25}/>
                        <div>No video clip</div>
                    </div>
                </div>
            )}
            
        </div>
    )
}
